import "./src/styles/fonts.css"
import "./src/styles/global.css"

// Welcome message for curious developers
export const onClientEntry = () => {
  console.log(
    '%c👋 Hey Developer!',
    'font-size: 24px; font-weight: bold; color: #667eea;'
  );
  console.log(
    '%cLike building stuff? Check out these tutorials:',
    'font-size: 14px; color: #374151; margin-top: 8px;'
  );
  console.log(
    '%c🎯 Build a Portfolio → /tutorials/portfolio-laravel (Laravel, Flask, or vanilla JS)',
    'font-size: 13px; color: #059669;'
  );
  console.log(
    '%c📝 Build a Blog → /tutorials/blog-laravel (Laravel, Flask, or vanilla JS)',
    'font-size: 13px; color: #059669;'
  );
  console.log(
    '%c🛒 Build E-Commerce → /tutorials/shopping-laravel (Laravel, Flask, or vanilla JS)',
    'font-size: 13px; color: #059669;'
  );
  console.log(
    '%c☁️ Build R2 Media Manager → /tutorials/r2-media-manager',
    'font-size: 13px; color: #059669;'
  );
  console.log(
    '%cEach tutorial includes AI-assisted prompts for every step. Go build something cool! 🚀',
    'font-size: 13px; color: #6b7280; margin-top: 8px;'
  );
};

// Add copy buttons to all code blocks after route change
export const onRouteUpdate = () => {
  // Add copy buttons to all code blocks - try multiple selectors
  const codeBlocks = document.querySelectorAll('pre[class*="language-"], .blog-content pre, pre code');

  // Get unique pre elements
  const uniquePres = new Set<HTMLElement>();
  codeBlocks.forEach((el) => {
    const pre = el.tagName === 'PRE' ? el : el.closest('pre');
    if (pre) uniquePres.add(pre as HTMLElement);
  });

  uniquePres.forEach((pre) => {
    // Skip if copy button already exists
    if (pre.parentElement?.querySelector('.code-copy-button')) {
      return;
    }

    // Create wrapper if it doesn't exist
    let wrapper = pre.parentElement;
    if (!wrapper?.classList.contains('code-block-wrapper')) {
      wrapper = document.createElement('div');
      wrapper.className = 'code-block-wrapper';
      pre.parentNode?.insertBefore(wrapper, pre);
      wrapper.appendChild(pre);
    }

    // Create copy button
    const button = document.createElement('button');
    button.className = 'code-copy-button';
    button.innerHTML = `
      <svg class="copy-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
      </svg>
      <span class="copy-text">Copy</span>
    `;
    button.setAttribute('aria-label', 'Copy code to clipboard');

    // Add click handler
    button.addEventListener('click', async () => {
      const code = pre.querySelector('code')?.textContent || pre.textContent || '';

      try {
        await navigator.clipboard.writeText(code);
        button.classList.add('copied');
        const copyText = button.querySelector('.copy-text');
        if (copyText) {
          copyText.textContent = 'Copied!';
        }

        setTimeout(() => {
          button.classList.remove('copied');
          if (copyText) {
            copyText.textContent = 'Copy';
          }
        }, 2000);
      } catch (err) {
        console.error('Failed to copy code:', err);
      }
    });

    wrapper.appendChild(button);
  });
};
